import { render, staticRenderFns } from "./description-list.vue?vue&type=template&id=117ac58c&scoped=true"
import script from "./description-list.vue?vue&type=script&setup=true&lang=js"
export * from "./description-list.vue?vue&type=script&setup=true&lang=js"
import style0 from "./description-list.vue?vue&type=style&index=0&id=117ac58c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117ac58c",
  null
  
)

export default component.exports